import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach token from localStorage if available (fallback to cookies)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("nk_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const CATEGORIES = [
  { slug: "rajya", name: "ರಾಜ್ಯ", en: "State" },
  { slug: "rashtriya", name: "ರಾಷ್ಟ್ರೀಯ", en: "National" },
  { slug: "kride", name: "ಕ್ರೀಡೆ", en: "Sports" },
  { slug: "cinema", name: "ಸಿನಿಮಾ", en: "Cinema" },
  { slug: "vyapara", name: "ವ್ಯಾಪಾರ", en: "Business" },
  { slug: "tantrajnana", name: "ತಂತ್ರಜ್ಞಾನ", en: "Technology" },
];

export const categoryName = (slug) =>
  CATEGORIES.find((c) => c.slug === slug)?.name || slug;

export function formatApiError(detail) {
  if (detail == null) return "ಏನೋ ತಪ್ಪಾಗಿದೆ. ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function timeAgoKannada(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const secs = Math.floor((Date.now() - d.getTime()) / 1000);
  if (secs < 60) return "ಈಗ";
  const mins = Math.floor(secs / 60);
  if (mins < 60) return `${mins} ನಿಮಿಷಗಳ ಹಿಂದೆ`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs} ಗಂಟೆಗಳ ಹಿಂದೆ`;
  const days = Math.floor(hrs / 24);
  if (days < 30) return `${days} ದಿನಗಳ ಹಿಂದೆ`;
  return d.toLocaleDateString("kn-IN");
}
